import orderDetailInfo from "./components/orderDetailInfo";
import orderDetailProduct from "./components/orderDetailProduct";
import orderDetailTransport from "./components/orderDetailTransport";
export default {
  name: 'orderDetail',
  i18n: require('./i18n-orderDetail'),
  components: {
    orderDetailInfo: orderDetailInfo,
    orderDetailProduct: orderDetailProduct,
    orderDetailTransport: orderDetailTransport
  },
  data: function data() {
    return {
      orderInfo: {},
      activeKey: '1'
    };
  },
  mounted: function mounted() {
    this.activeKey = this.$route.query.activeKey ? '2' : '1';
  },
  methods: {
    change: function change(e) {
      this.activeKey = e;
    }
  }
};